import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Divider, IconButton, InputBase, Paper } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { SVGIcon } from '@custom-components';
import { SearchIconWrapper, styles } from './SearchBar.styles';
import { colorBlue } from '../../css/colors';

function SearchBarU(props) {
  const { classes, submitSearch, placeholder, name, value: inputValue, type } = props;

  const rawInputTypes = ['string', 'number'];
  const value = rawInputTypes.includes(typeof inputValue) ? inputValue : inputValue?.query;

  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
  }, [value]);

  const handleSubmit = (e, v) => {
    const submissionValue = type === 'number' ? +v : v;
    e.preventDefault();
    submitSearch(submissionValue);
  };

  return (
    <form autoComplete="off" onSubmit={(e) => handleSubmit(e, currentValue)}>
      <Paper className={classes.root} elevation={2}>
        <InputBase
          className={classes.input}
          name={name}
          placeholder={placeholder}
          value={currentValue ?? ''}
          onChange={(e) => setCurrentValue(e.target.value)}
          type={type}
        />
        <SearchIconWrapper>
          <Divider className={classes.divider} />
          <IconButton
            className={classes.button}
            aria-label="Search"
            onClick={(e) => handleSubmit(e, currentValue)}
            size="large">
            <SVGIcon selectedIcon="search" iconColor={colorBlue} />
          </IconButton>
        </SearchIconWrapper>
      </Paper>
    </form>
  );
}

SearchBarU.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    input: PropTypes.string,
    divider: PropTypes.string,
    button: PropTypes.string
  }).isRequired,
  submitSearch: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string
};

SearchBarU.defaultProps = {
  placeholder: 'Search',
  type: 'text',
  value: ''
};

export const SearchBar = withStyles(styles)(SearchBarU);
